import { FieldType, TemplateGroup } from "./types";

const templateDefs: TemplateGroup[] = [
  {
    name: "Most used",
    templates: [
      {
        name: "First & Last",
        icon: "contact_page",
        rows: [
          {
            fields: [
              { type: FieldType.text, name: "First Name" },
              { type: FieldType.text, name: "Last Name" },
            ],
          },
        ],
      },
      {
        name: "Date Of Birth",
        icon: "today",
        rows: [{ fields: [{ type: FieldType.date, name: "Date Of Birth" }] }],
      },
      {
        name: "Name",
        icon: "person",
        rows: [{ fields: [{ type: FieldType.text, name: "Name" }] }],
      },
      {
        name: "Date",
        icon: "today",
        rows: [{ fields: [{ type: FieldType.date, name: "Date" }] }],
      },
      {
        name: "Address",
        icon: "home",
        rows: [
          {
            fields: [
              { type: FieldType.text, name: "Zip" },
              { type: FieldType.text, name: "State" },
            ],
          },
          {
            fields: [{ type: FieldType.text, name: "Address" }],
          },
        ],
      },
      {
        name: "Phone",
        icon: "phone",
        rows: [
          {
            fields: [{ type: FieldType.text, name: "Phone" }],
          },
        ],
      },
      {
        name: "Email",
        icon: "email",
        rows: [
          {
            fields: [{ type: FieldType.text, name: "Email" }],
          },
        ],
      },
      {
        name: "Gender",
        icon: "favorite",
        rows: [
          {
            fields: [
              {
                type: FieldType.select,
                name: "Gender",
                options: ["Male", "Female", "Other"],
              },
            ],
          },
        ],
      },
      {
        name: "Country",
        icon: "language",
        rows: [
          {
            fields: [
              {
                type: FieldType.select,
                name: "Country",
                options: ["Germany", "Japan"],
              },
            ],
          },
        ],
      },
      {
        name: "Number",
        icon: "numbers",
        rows: [
          {
            fields: [
              {
                type: FieldType.text,
                name: "Number",
              },
            ],
          },
        ],
      },
      {
        name: "Payment",
        icon: "attach_money",
        rows: [
          {
            fields: [
              {
                type: FieldType.text,
                name: "Payment",
              },
            ],
          },
        ],
      },
      {
        name: "Take Picture/Upload File(s)",
        icon: "image",
        rows: [
          {
            fields: [
              {
                type: FieldType.file,
                name: "Take Picture/Upload File(s)",
              },
            ],
          },
        ],
      },
      {
        name: "Signature",
        icon: "edit",
        rows: [
          {
            fields: [
              {
                type: FieldType.signature,
                name: "Signature",
                full_width: true,
                required: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Basic",
    templates: [
      {
        name: "Text Input",
        icon: "input",
        rows: [
          {
            fields: [
              {
                type: FieldType.text,
                name: "Text Input",
              },
            ],
          },
        ],
      },
      {
        name: "Multiline Text Input",
        icon: "notes",
        rows: [
          {
            fields: [
              {
                type: FieldType.multiline_text,
                name: "Multiline Text Input",
                multiline: true,
                rows: 4,
              },
            ],
          },
        ],
      },
      {
        name: "Checkbox",
        icon: "check_box",
        rows: [
          {
            fields: [
              {
                type: FieldType.checkbox,
                name: "Checkbox",
              },
            ],
          },
        ],
      },
      {
        name: "Radio Group",
        icon: "radio_button_checked",
        rows: [
          {
            fields: [
              {
                type: FieldType.radio_group,
                name: "Radio Group",
                options: ["Choice 1", "Choice 2"],
              },
            ],
          },
        ],
      },
      {
        name: "Single Choice",
        icon: "playlist_add_check",
        rows: [
          {
            fields: [
              {
                type: FieldType.select,
                name: "Single Choice",
                options: ["Choice 1", "Choice 2"],
              },
            ],
          },
        ],
      },
      {
        name: "Multiple Choice",
        icon: "checklist_rtl",
        rows: [
          {
            fields: [
              {
                type: FieldType.select,
                name: "Multiple Choice",
                options: ["Choice 1", "Choice 2"],
                multiline: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Content",
    templates: [
      {
        name: "Image",
        icon: "image",
        rows: [
          {
            fields: [
              {
                type: FieldType.image,
                name: "Image",
                readonly: true,
                full_width: true,
              },
            ],
          },
        ],
      },
      {
        name: "Waiver Text",
        icon: "format_size",
        rows: [
          {
            fields: [
              { type: FieldType.paragraph, full_width: true, readonly: true },
            ],
          },
        ],
      },
      {
        name: "Empty Block",
        icon: "crop_16_9",
        rows: [
          {
            fields: [],
          },
        ],
      },
    ],
  },
];

export default templateDefs;
